import { MissingTranslationHandler } from '@ngx-translate/core';

/**
 * Manage missing translation and i18n file downloading duration
 */
export class EcmMissingTranslationHandler implements MissingTranslationHandler {
    public handle() {
        return '';
    }
}
